export const nftContractAddress = "0x146d7c3c6db42966472051abaa5f817cf22d3071"; 
export const totalSupply = 5000;
export const maxPerWallet = 10;
export const maxPerTx = 5;

export const boolDontMint = false;
export const checkIDchain = '0x1';   //GOERLI    '0x5 '   mainnet  '0x1'    Sepolia '0x46'
export const mintDateTimer = "";   // Jak jest 0 to nie pokazuje '02 19, 2023 20:50:00' 
export const openSeaLink = "https://opensea.io/collection/0x146d7c3c6db42966472051abaa5f817cf22d3071"  // testnet